<template>
    <div>
        <vapp-header btnBack></vapp-header>
        <div class="container" style="padding-top: 15px">
            <div class="row">
                <div class="col-md-12">
                    <!--<div class="add-customer">-->
                    <!--<b-link href="/create_item">-->
                    <!--<img src="@/assets/images/ic_add_item.svg">-->
                    <!--<span>Add New Item</span>-->
                    <!--</b-link>-->
                    <!--</div>-->
                    <!--<label>Items</label>-->
                    <ul class="data-list">
                        <li v-for="(product, index) in products" :key="index" @click="pushItem(product)">
                            <div class="data-circle">
                                <span>{{ product.name.charAt(0) }}</span>
                            </div>
                            <span>{{ product.name }}</span>
                            <hr>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!--<vapp-right-panel :thepage="'/create_item'"></vapp-right-panel>-->
    </div>
</template>

<script>
    import productSvc from '../../services/productService'
    import { mapState, mapActions } from 'vuex';
    export default {
        name: "SelectItemFromList",
        data() {
            return {
                products: [],
            }
        },
        computed: {
            ...mapState('company', ['selectedCompany']),
            ...mapState('invoice', ['createInvoiceObj', 'editInvoiceObj', 'isEditingInvoice'])
        },
        methods: {
            ...mapActions('invoice', ['setCreateInvoiceObj', 'setEditInvoiceItem']),
            pushItem(item) {
                let itemsToPush = {
                    product_id: item.id,
                    name: item.name,
                    quantity: 1,
                    unit_price: item.sale_price,
                    display_name: item.name
                };

                if (this.isEditingInvoice) {
                    if (this.editInvoiceObj.items === undefined){
                        itemsToPush.line = 1
                    } else {
                        itemsToPush.line = this.editInvoiceObj.items.length + 1;
                    }
                    this.setEditInvoiceItem(itemsToPush);
                } else {
                    if (this.createInvoiceObj.items === undefined){
                        itemsToPush.line = 1
                    } else {
                        itemsToPush.line = this.createInvoiceObj.items.length + 1;
                    }
                    this.setCreateInvoiceObj({ items: itemsToPush })
                }
                
                this.$router.go(-1)
            }
        },
        mounted() {
            console.log("Mounted : Select Item From List");
            let config = {
                params: {
                    for_sale: true
                }
            };
            productSvc.methods.getProducts(this.selectedCompany, config)
                .then(data => {
                    this.products = data.products
                })
        }
    }
</script>

